// Anchor tabs: smooth-scroll on click + active state from scroll position.
(function () {
  const root = document.querySelector("[data-anchor-tabs]");
  if (!root) return;

  // Shopify wraps each section in <div class="shopify-section">. For
  // position:sticky to work, the wrapper (not the inner <section>) is what
  // needs sticky — its parent is <main>, which contains all sibling sections
  // to scroll past. Tag the wrapper so CSS can target it without :has().
  const wrapper = root.closest(".shopify-section");
  if (wrapper) wrapper.classList.add("shopify-section--sticky-tabs");

  const links = Array.from(root.querySelectorAll(".anchor-tabs__link"));
  const targets = links
    .map((a) => ({ link: a, el: document.getElementById(a.dataset.target) }))
    .filter((t) => t.el);

  // Absolute document top of an element (handles Shopify section wrappers
  // that aren't positioned at body level).
  function docTop(el) {
    return el.getBoundingClientRect().top + window.scrollY;
  }

  // Offset to subtract when scrolling — bar height if it's visible.
  function scrollOffset() {
    return root.getBoundingClientRect().height;
  }

  // Smooth scroll on click.
  links.forEach((a) => {
    a.addEventListener("click", (e) => {
      const el = document.getElementById(a.dataset.target);
      if (!el) return;
      e.preventDefault();
      const top = docTop(el) - scrollOffset();
      window.scrollTo({ top, behavior: "smooth" });
      history.replaceState(null, "", `#${a.dataset.target}`);
    });
  });

  // CTA: smooth-scroll back to the top of the page.
  const ctaScrollTop = root.querySelector("[data-scroll-top]");
  if (ctaScrollTop) {
    ctaScrollTop.addEventListener("click", (e) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
      // Strip any lingering hash so history is clean.
      if (location.hash)
        history.replaceState(null, "", location.pathname + location.search);
    });
  }

  // Highlight active section while scrolling. The active section is the
  // last one whose top is above the viewport's reading line.
  function onScroll() {
    const readingLine = window.scrollY + scrollOffset() + 4;
    let activeIdx = -1;
    targets.forEach((t, i) => {
      if (docTop(t.el) <= readingLine) activeIdx = i;
    });
    links.forEach((a, i) => a.classList.toggle("is-active", i === activeIdx));
  }

  let ticking = false;
  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    },
    { passive: true },
  );
  window.addEventListener("resize", onScroll, { passive: true });
  onScroll();
})();
